var render = function () {
  var _vm$eventFlow;

  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "d-flex position-relative grid-container",
    on: {
      "dragover": function dragover($event) {
        $event.preventDefault();
        return function () {}.apply(null, arguments);
      },
      "drop": function drop($event) {
        $event.preventDefault();
        return function () {}.apply(null, arguments);
      }
    }
  }, [_c('event-flow-legend', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.extraFunctionFormData.showLegend,
      expression: "extraFunctionFormData.showLegend"
    }],
    attrs: {
      "responsibles": _vm.responsibles
    }
  }), _c('div', {
    staticClass: "d-flex flex-column"
  }, [_c('timeline-grid', {
    staticClass: "header-height",
    attrs: {
      "time-values": _vm.timeValues
    }
  })], 1), _c('div', {
    staticClass: "d-flex position-relative border-grid-container w-100",
    attrs: {
      "id": "box2"
    }
  }, [_c('div', {
    staticClass: "timeline-border-grid"
  }, [_c('grid', {
    attrs: {
      "length": _vm.timeValues.length
    }
  }, [_vm._l(_vm.timeValues, function (timeValue, timeLineRowIndex) {
    return [_vm.showBorder(timeValue) ? _c('div', {
      key: "timeline-border-".concat(timeLineRowIndex, "-").concat(timeValue),
      class: {
        'timeline-border-3': _vm.getMinuteStringFromTimeString(timeValue) === '00',
        'timeline-border-2': _vm.getMinuteStringFromTimeString(timeValue) === '30',
        'timeline-border-1': _vm.getMinuteStringFromTimeString(timeValue) === '15'
      },
      style: {
        'grid-row': timeLineRowIndex + 1
      }
    }) : _vm._e()];
  })], 2)], 1), _vm._l((_vm$eventFlow = _vm.eventFlow) === null || _vm$eventFlow === void 0 ? void 0 : _vm$eventFlow.eventFlowLocations, function (eventFlowLocation, index) {
    return _c('location-header', {
      key: "grid-location-name-".concat(eventFlowLocation.id),
      attrs: {
        "event-flow-location": eventFlowLocation,
        "index": index,
        "is-last": index == _vm.eventFlowLocations.length - 1
      }
    }, _vm._l(eventFlowLocation.eventFlowTopics, function (eventFlowTopic) {
      return _c('topic-grid', {
        key: "event-flow-dropzone-location-".concat(eventFlowLocation.id, "-topic-").concat(eventFlowTopic.id),
        attrs: {
          "event-flow-location": eventFlowLocation,
          "event-flow-topic": eventFlowTopic,
          "moved-object": _vm.movedObject,
          "length": _vm.timeValues.length - 1
        },
        on: {
          "item-changed-local": _vm.itemChangedLocal
        }
      }, _vm._l(eventFlowTopic.items, function (eventFlowItem, itemIndex) {
        return _c('grid-item', {
          directives: [{
            name: "b-tooltip",
            rawName: "v-b-tooltip.hover.right.noninteractive.html",
            value: _vm.createTooltipText(eventFlowItem),
            expression: "\n                        createTooltipText(eventFlowItem)\n                    ",
            modifiers: {
              "hover": true,
              "right": true,
              "noninteractive": true,
              "html": true
            }
          }],
          key: "event-flow-item-".concat(eventFlowItem.id),
          attrs: {
            "index": itemIndex,
            "event-flow-item": eventFlowItem,
            "is-sheet": _vm.isSheet,
            "start-date-time": _vm.startDateTime,
            "end-date-time": _vm.endDateTime,
            "last-pos": _vm.lastPos,
            "step": _vm.step,
            "time-values-length": _vm.timeValues.length,
            "extra-data": _vm.extraFunctionFormData
          }
        });
      }), 1);
    }), 1);
  })], 2)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }